import {ADD_OUTSTANDING_ITEM, REMOVE_OUTSTANDING_ITEM} from "./actionTypes"

export const reducer = (state = [], action) => {
    const item = {
        GST: 0.01,
        calendar: "Aliaksei Piatrouski",
        calendarID: 6450363,
        clientRate: 0.22,
        counsellor: undefined,
        counsellorRate: 0.17,
        date: "February 18, 2022",
        email: "",
        firstName: "Pop",
        icbcClaimNumber: undefined,
        id: "761309517",
        lastName: "it",
        paid: "no",
        paymentSource: "Low Cost (practicum/intern rate)",
        phone: "4685131315",
        price: 0.23,
        selected: false,
        sessionLocation: "Contractor location",
        time: "13:30",
        totalBilled: undefined,
        type: "Remote Couples Counselling Session",
    }
    return [item]
}